export const getSingleExecutionFetching = (state) => state?.executions?.singleFetching;
export const getExecutionListingFetching = (state) => state?.executions?.listingFetching;

export const getExecutionData = (state, id) => state?.executions?.[`/execution/${id}`];
export const getExecutionsData = (state) => state?.executions?.executionsList;
